import type { ReactNode } from 'react'
import { cx } from './utils/cx'

export type BannerTone = 'yellow' | 'sky'

// SnapTransfer extension — not part of the reference component library.
// Full-width strip under the dashboard top bar for account- or app-level
// notices (paused features, a newer deploy). Styles live in components.css
// under .st-banner; actions use .st-banner-action so links and buttons match.
export function Banner({
  tone = 'yellow',
  sticky,
  role = 'alert',
  action,
  children
}: {
  tone?: BannerTone
  sticky?: boolean
  role?: 'alert' | 'status'
  action?: ReactNode
  children?: ReactNode
}) {
  return (
    <div className={cx('st-banner', tone, sticky && 'sticky')} role={role}>
      <span className="st-banner-msg">{children}</span>
      {action && <span className="st-banner-actions">{action}</span>}
    </div>
  )
}
